<div class="card-list" [ngClass]="{'-fade': showList}">
  <ng-container *ngFor="let item of poses | posfilter: filterBy">
    <div class="card" *ngIf="item !== -1">
      <div class="card__row">
        <div class="card__col -col-left">
          <p class="card__title">{{ item.displayName }}</p>
          <div class="card__content">
            <address class="card__address">
              <span  class="card__address__street">{{item?.address?.street}}</span> 
              <br><span class="card__address__code">{{item?.address?.postalCode}}</span> <span class="card__address__town">{{item?.address?.town}}</span>
            </address>
            <div class="card__contact">
              <p class="card__phone"><span class="card__phone-text">{{ item?.address?.phone }}</span></p>
              <a href="mailto:{{ item?.address?.mail }}" class="card__mail"><span class="card__mail-text">{{ item?.address?.mail }}</span></a>
            </div>
          </div>
        </div>
        <div class="card__col -second-col">
          <div class="card__time">
            <p class="card__time__title">{{'map.pos.openhours.text' | translate }}</p>
            <ul class="card__time__list">
              <li class="card__time__days" *ngFor="let hour of item.openingHours">{{ hour }}</li>
            </ul>
          </div>
          <a class="card__btn" href="{{item.appoitmentUrl}}">{{'map.pos.button.text' | translate }}</a>
        </div>
      </div>
    </div>
    <p class="card-error-message" *ngIf="item === -1 && currentLocation !== null">
      {{"map.pos.list.empty" | translate}}
    </p>
  </ng-container>
</div>
